import { Routes } from "@angular/router";
import { LoginComponent } from "./common/loginViews/login";
import { NoContentComponent } from "./no-content";
import { AuthGuard } from "./guards/auth.guard";
import { LogoutComponent } from "./common/logout/logout.component";
import { ExternalLoginComponent } from "./common/loginViews/externalLogin";
import { PasswordResetComponent } from "./common/loginViews/passwordReset/passwordReset.component";


export const ROUTES: Routes = [
  // General App views
  {path: "login", component: LoginComponent},
  {path: "", redirectTo: "login", pathMatch: "full"},
  {path: "externalLogin", component: ExternalLoginComponent},
  {path: "passwordreset", component: PasswordResetComponent},
  {path: "logout", component: LogoutComponent},
  {path: "registration", loadChildren: "./common/registration#RegistrationModule", canActivate: [AuthGuard]},
  {path: "**", component: NoContentComponent},
];
